import { forwardRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '@/assets/styles/components/datepicker-input.styles.scss';
import dayjs from 'dayjs';
import { If } from 'vite-plugin-react-control-statements';

interface CustomDateRangeInputProps {
	value?: string;
	label?: string | null;
	onClick?: () => void;
	placeholderLabel?: string;
}

export const CustomDateRangeInput = forwardRef<HTMLDivElement, CustomDateRangeInputProps>(({ value, onClick, label, placeholderLabel }, ref) => {
	const formatValue = (): string => {
		if (!value) return '';

		const dates = value.toString().split(' - ');
		if (dates.length === 2) {
			const start = dayjs(dates[0], 'MM/DD/YYYY');
			const end = dayjs(dates[1], 'MM/DD/YYYY');

			if (start.isValid() && end.isValid()) {
				return `${start.format('DD MMMM YYYY')} - ${end.format('DD MMMM YYYY')}`;
			}
			if (start.isValid()) {
				return `${start.format('DD MMMM YYYY')} - ...`;
			}
		}

		return value.toString();
	};

	return (
		<div className="custom-datepicker-input-wrapper">
			<If condition={!!label}>
				<label className="custom-datepicker-label">{label}</label>
			</If>
			<div
				ref={ref}
				onClick={onClick}
				className="custom-datepicker-input">
				<span>{formatValue() || placeholderLabel || 'Tarih aralığı seçin'}</span>
				<i className="icons-alt-arrow-down" />
			</div>
		</div>
	);
});
